export class TranslationController {
    constructor(host, func) {
        host.addController(this);
        this._func = func;
    }
    hostConnected() {
        window.addEventListener('updateTranslation', this._func);
    }
    hostDisconnected() {
        window.removeEventListener('updateTranslation', this._func);
    }
}
//# sourceMappingURL=TranslationController.js.map